module.exports = __webpack_public_path__ + "img/browse_comm_icon@2x.0fc27316.png";